
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyPilarEast as ObiBuoyPilarEastElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-pilar-east.js';
 
 
 

 
 export const ObiBuoyPilarEast = createComponent({
   react: React,
   tagName: 'obi-buoy-pilar-east',
   elementClass: ObiBuoyPilarEastElement,
   events: {
     
   }
  });
 
 